<template>
  <div>
    <Search></Search>
    <!-- <div id="container" style="width: 100%; height: 500px"></div> -->
    <div class="location">
      <div>
        <div class="head"><p>当前城市</p></div>
        <div class="city">
          <div class="area">
            {{ $store.state.location.locationInfo.city }}
          </div>
          <div class="refresh">
            <button @click="getMyLocation">
              <i :class="rotate ? 'rotate' : ''"></i>
              <span>重新定位</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <div class="head"><p>热门城市</p></div>
        <div class="list">
          <ul>
            <li
              v-for="(item, index) of hotCity"
              :key="index"
              @click="setLocation(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div>
        <van-index-bar>
          <div v-for="(item, index) of moveCity" :key="index">
            <van-index-anchor :index="item.name" />
            <van-cell
              v-for="(item2, index2) of item.citys"
              :key="index2"
              :title="item2"
              @click="setLocation(item2)"
            />
          </div>
        </van-index-bar>
      </div>
    </div>
  </div>
</template>
<script>
import Search from '@/components/search'

export default {
  name: 'location',
  components: {
    Search,
  },
  data () {
    return {
      longitude: 0,//经度
      latitude: 0,//纬度
      rotate: false,
      hotCity: [
        { cityId: 1, name: '北京' },
        { cityId: 2, name: '上海' },
        { cityId: 3, name: '深圳' },
        { cityId: 4, name: '杭州' },
        { cityId: 5, name: '重庆' },
        { cityId: 6, name: '青岛' },
        { cityId: 7, name: '昆明' },
        { cityId: 8, name: '兰州' },
        { cityId: 9, name: '西安' },
      ],
      moveCity: [
        {
          name: "A",
          citys: ["阿坝", "阿拉善", "阿里", "安康", "安庆", "鞍山", "安顺", "安阳", "澳门"]
        },
        {
          name: "B",
          citys: ["北京", "白银", "保定", "宝鸡", "保山", "包头", "巴中", "北海", "蚌埠", "本溪", "毕节", "滨州", "百色", "亳州"]
        },
        {
          name: "C",
          citys: ["重庆", "成都", "长沙", "长春", "沧州", "常德", "昌都", "长治", "常州", "巢湖", "潮州", "承德", "郴州", "赤峰", "池州", "崇左", "楚雄", "滁州", "朝阳"]
        },
        {
          name: "D",
          citys: ["大连", "东莞", "大理", "丹东", "大庆", "大同", "大兴安岭", "德宏", "德阳", "德州", "定西", "迪庆", "东营"]
        },
      ]
    }
  },
  methods: {
    async getMyLocation () {
      // var geolocation = new qq.maps.Geolocation("key=IGUBZ-DGX6U-WWKV3-2UPDP-MENHS-J4FDY", "userLocation");
      // geolocation.getLocation(this.showPosition, this.showErr);//或者用getLocation精确度比较高
      this.rotate = true
      try {
        await this.$store.dispatch('location/getLocation')
        this.rotate = false
      } catch (err) {
        this.getMyLocation()
        // console.log(err)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.location {
  font-size: 0.28rem;
  padding: 0.2rem;
  .head {
    font-weight: 800;
  }
  .list {
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 1.8rem;
        border: 1px solid #707070;
        height: 0.65rem;
        margin: 0.1rem 0.25rem;
        line-height: 0.65rem;
        text-align: center;
        border-radius: 30px;
      }
    }
  }
  .city {
    display: flex;
    align-items: center;
    .area {
      border: 1px solid black;
      border-radius: 30px;
      width: 1.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      text-align: center;
      margin-right: 10px;
    }
    .refresh {
      button {
        border-radius: 30px;
        padding: 0.1rem;
        border: 1px solid black;
        text-align: center;
        display: flex;
        align-items: center;
        i {
          width: 0.3rem;
          height: 0.3rem;
          background: url("../../assets/icon/refresh.png") no-repeat 50%/100%;
        }
      }
    }
  }
}

@keyframes myRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rotate {
  animation: 0.5s myRotate infinite;
}
</style>